require('./hireCardAtHomeAbroadStep3.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @ constants
const {
    ACCOUNT_INTERVENTION_AUTHORIZED,
    ACCOUNT_INTERVENTION_CO_OWNER,
    ACCOUNT_INTERVENTION_OWNER,
    ACCOUNT_INTERVENTION_REPRESENTATIVE,
    CHECKING_ACCOUNT_CODE,
    EURO_TEXT,
    THIRD_STEP
} = require('constants/index');
const {
    ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES
} = require('constants/accounts');

class HireCardAtHomeAbroadStep3 extends React.Component {

    componentDidMount() {
        const { immAccounts, setAllAccountsToInactive } = this.props;
        const allAccountsInactive = hasAllAccountsInactive(this.filterAccounts(), immAccounts.get('byId'));
        if(allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }


    filterAccounts() {
        const { immAccounts } = this.props;
        const interventionTypes = [
            ACCOUNT_INTERVENTION_AUTHORIZED,
            ACCOUNT_INTERVENTION_OWNER,
            ACCOUNT_INTERVENTION_CO_OWNER,
            ACCOUNT_INTERVENTION_REPRESENTATIVE
        ];
        const accountsIndexes = immAccounts.get('byOrder').filter( accountId =>
            // We remove the accounts that are not in euros
            immAccounts.getIn(['byId', accountId, 'balance', 'currency']) === EURO_TEXT
        ).filter( accountId =>
            // We remove the accounts that don't comply with the requisites of product type and subtype
            immAccounts.getIn(['byId', accountId, 'newProduct']) === String(CHECKING_ACCOUNT_CODE) &&
            ACCOUNTS_WITH_CHEQUES_OR_DEBITS_SUBTYPES.includes(immAccounts.getIn(['byId', accountId, 'accountType']))
        ).filter( accountId =>
            // We remove the accounts where the user is not the owner
            interventionTypes.includes(immAccounts.getIn(['byId', accountId, 'interventionType']))
        );

        // We return an array with the ids of the filtered accounts
        return accountsIndexes.toJS();
    }

    render() {
        const {
            handleAccountChange,
            immAccounts,
            immHireCardAtHomeAbroad,
            isInactiveAccountsEnabled,
        } = this.props;
        const immStep3 = immHireCardAtHomeAbroad.getIn(['steps', THIRD_STEP]);
        const accountErrorMsgVisible = immStep3.get('accountIsDirty') && !immStep3.get('accountId');
        const accountErrorMsg = formatText('hireCardAtHomeAbroad-step3SelectAccountError');
        const accountLabel = formatText('hireCardAtHomeAbroad-step3SelectAccount');
        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-hireCardAtHomeAbroadLinkURL');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');

        return (
            <article className="hire-card-at-home-abroad-step-three">
                <FormattedText
                    className="hire-card-at-home-abroad__step-title"
                    value="hireCardAtHomeAbroad-step3Title"
                />
                <DropdownAccounts
                    accountsIndexes={this.filterAccounts()}
                    blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                    currentAccountId={immStep3.get('accountId')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    onAccountChange={handleAccountChange}
                    showAvailableBalance={true}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    loading={isBlockedAccountsLoading}
                />
                <div className="hire-card-at-home-abroad-step-three__disclaimer-personal-info">
                    <OKMessage
                        type="informative"
                    >
                        <FormattedText value="disclaimerPersonalInfo-hireCardAtHomeAbroadMsg" />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value="disclaimerPersonalInfo-hireCardAtHomeAbroadLinkText" />
                        </OKLink>
                    </OKMessage>
                </div>
            </article>
        );
    }
}

HireCardAtHomeAbroadStep3.propTypes = {
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardAtHomeAbroad: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired
};

module.exports = HireCardAtHomeAbroadStep3;
